




































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'ProfileTeo',
  // props: {
  // },
  components: {},
  setup: () => {
    return {};
  }
});
